"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
var _callFunc = _interopRequireDefault(require("call-func"));
var _getDefaultValue = _interopRequireDefault(require("./getDefaultValue.js"));
//@ts-check

/**
 * @see https://github.com/react-atomic/reshow/issues/123
 * @param {object} o
 * @param {string|number} k
 * @returns {any}
 */
var getter = function getter(o, k) {
  var _ref;
  return (_ref = o.size && (0, _callFunc["default"])(o.get, [k], o)) !== null && _ref !== void 0 ? _ref : o[k];
};

/**
 * @param {any} o
 * @param {(string | number | undefined)[]} path
 * @param {any} defaultValue
 * @returns {any}
 */
var get = function get(o, path, defaultValue) {
  if (path === void 0) {
    path = [];
  }
  if (defaultValue === void 0) {
    defaultValue = _reshowConstant.T_UNDEFINED;
  }
  if (null == o) {
    return (0, _getDefaultValue["default"])(defaultValue, {
      obj: o
    });
  }
  var current = o;
  if (!path || !(0, _reshowConstant.IS_ARRAY)(path) || !path.length) {
    return current;
  }
  try {
    var i = path.length;
    var j = path.length - 1;
    while (i--) {
      var index = path[j - i];
      if (null != current) {
        var next = getter(current, /** @type any*/index);
        if (_reshowConstant.UNDEFINED !== typeof next) {
          current = next;
        } else {
          current = (0, _getDefaultValue["default"])(defaultValue, {
            obj: o,
            prev: current,
            next: next,
            nextIndex: index,
            path: path
          });
          break;
        }
      } else {
        current = (0, _getDefaultValue["default"])(defaultValue);
        break;
      }
    }
  } catch (e) {
    console.warn({
      e: e
    });
    current = (0, _getDefaultValue["default"])(defaultValue);
  }
  return current;
};
var _default = exports["default"] = get;
module.exports = exports.default;